module.exports = __webpack_public_path__ + "advisory-8c397925/praktikumsbericht-4df31a0cd92a38fbcc39774b7ff72f03.jpeg";